import { SfccRefundMethod } from "@redotech/congo-enums/sfcc-refund-method";
import type { infer as zInfer } from "zod";
import { object, enum as zEnum } from "zod";
import { commerceCloudIntegrationTarget } from "./list-commerce-cloud-integrations";

export const setCommerceCloudRefundMethod = {
  name: "setCommerceCloudRefundMethod" as const,
  input: object({
    refundMethod: zEnum(SfccRefundMethod),
    target: commerceCloudIntegrationTarget,
  }),
  output: object({ success: object({}).optional() }),
};

export type SetCommerceCloudRefundMethodInput = zInfer<
  typeof setCommerceCloudRefundMethod.input
>;
export type SetCommerceCloudRefundMethodOutput = zInfer<
  typeof setCommerceCloudRefundMethod.output
>;
